// utils/config.js (or any file where you store your config)

export const config = {
    routes: [
        "/home",
        "/offers",
        "/history",
        "/transactions",
        "/digital-receipt",
        "/profile",
        "/my-profile",
    ],
    clientAccess: [
        { access_type: "VC", access_desc: "Voucher", enabled: false },
        { access_type: "SP", access_desc: "Share Points", enabled: false },
        { access_type: "DB", access_desc: "Download Voucher", enabled: false },
        { access_type: "BH", access_desc: "Bill History", enabled: true },
        { access_type: "DM", access_desc: "Dark Mode", enabled: true },
        { access_type: "HO", access_desc: "Home", enabled: false },
        { access_type: "OF", access_desc: "Offers", enabled: false },
        { access_type: "PR", access_desc: "Profile", enabled: true },
    ],
    routeMapping: {
        "/home": "Home",
        "/offers": "Offers",
        "/history": "Bill History",
        "/transactions": "Transactions",
        "/digital-receipt": "Download Voucher",
        "/profile": "Profile",
        "/my-profile": "Profile",
    },
};
